import $ from 'jquery';

export default class FileUpload {
    constructor(element) {
        this.element = element;
        this.elementName = element.name;
        this.id = element.id;
        this.templateUrl = element.getAttribute('data-template-uri');
        this.uploadUrl = element.getAttribute('data-upload-uri');
        this.dropzone = '#' + element.getAttribute('data-related-dropzone');
    }

    init() {
        let ninjaElement = document.createElement('div'),
            attr;
        ninjaElement.classList.add('hidden');
        ninjaElement.classList.add('old-virtual');

        for (let i = 0; i < this.element.attributes.length; i++) {
            attr = this.element.attributes[i];

            if (attr.specified) {
                ninjaElement.setAttribute(attr.name, attr.value);
            }
        }

        this.element.insertAdjacentHTML('afterend', ninjaElement.outerHTML);
        this.element.setAttribute('name', 'files[]');

        let self = this;

        this.addUpload(self);
    }

    addUpload(self) {
        $.ajax({
            url: self.templateUrl,
            method: 'POST',
            cache: false,
            dataType: 'json',
            data: {
                'fileid': self.element.getAttribute('data-value-id'),
                'name': self.elementName
            }
        }).done(function (response) {
            if (typeof response.html !== 'undefined') {

                let htmlDiv = document.createElement('div');
                htmlDiv.innerHTML = response.html;
                let test = document.querySelector('[role="file-upload"]');
                test.insertAdjacentHTML('afterend', response.html);
                self.dropZone = document.getElementById('drop-zone_' + self.elementName);

                self.gatherElementIds();
                self.checkMulti();

                $(self.element).fileupload({
                    url: self.uploadUrl,
                    autoUpload: true,
                    dataType: 'json',
                    dropZone: $(self.dropZone),
                    done: function (e, data) {

                        let response = $.parseJSON(data.jqXHR.responseText);

                        $(self.dropzone).removeClass('in');

                        $(document.getElementById('file-container_' + self.elementName)).append(response.html);

                        self.gatherElementIds();
                        self.checkMulti();
                    },
                    submit: function (e, data) {
                        data.formData = {
                            'name': self.elementName
                        };
                    }
                }).prop('disabled', !$.support.fileInput)
                    .parent().addClass($.support.fileInput ? undefined : 'disabled');
            }
        });

        $(document).on(
            'click',
            '.remove-element',
            function () {
                let id = $(this).parent().attr('data-image-id'),
                    toDelete = $(document.getElementById('upload-element_' + self.elementName + '_' + id));

                toDelete.remove();
                self.gatherElementIds();
                self.checkMulti();
            }
        )
    }

    gatherElementIds() {
        let valueContainer = document.getElementById('value-container_' + this.elementName),
            uploadElements = document.getElementsByClassName('upload-element');

        // empty the container
        while (valueContainer.firstChild) {
            valueContainer.removeChild(valueContainer.firstChild);
        }

        // add all possible inputs to the DOM
        for (let i = 0; i < uploadElements.length; i++) {
            let input = this.createHiddenInput();
            input.value = uploadElements[i].getAttribute('data-image-id');

            valueContainer.appendChild(input);
        }

        // if no current value is found, add an empty value to make sure the value will be submitted at least
        if (!valueContainer.hasChildNodes()) {
            let input = this.createHiddenInput();
            input.value = '';

            valueContainer.appendChild(input);
        }
    }

    checkMulti() {
        let valueContainer = document.getElementById('value-container_' + this.elementName),
            addElement = document.getElementById('visible-add-content-element_' + this.elementName);

        if (valueContainer.firstChild.value !== '' && !this.element.getAttribute('data-multi-upload')) {
            addElement.style.display = 'none';

            if (valueContainer.children.length >= 2) {
                alert('This upload is restricted to 1 file only!');
            }

        } else {
            addElement.style.display = '';
        }
    }

    createHiddenInput() {
        const input = document.createElement('input'),
            upldEl = document.getElementById(this.id);
        input.type = 'hidden';

        if (upldEl.hasAttribute('data-multi-upload') && upldEl.getAttribute('data-multi-upload') === '1') {
            input.name = this.elementName + '[]';
        } else {
            input.name = this.elementName;
        }

        return input;
    }
}
